<template>
  <div>
    <TopBar />
    <b-container class="main-content">
      <b-row>
        <b-col md class="mb-4">
          <h1>Hugster<br />🤗😘👋</h1>
          <p class="main-tagline">Get gentle reminders by text to reach out to friends while social distancing</p>
          <Info />
        </b-col>
        <b-col md class="mb-4">
          <div v-if="!isAuthenticated">
            <h4>Sign in to get started</h4>
            <Login />
            <p class="small mt-3">(Sorry, at the moment you need a Google account to use Hugster.)</p>
          </div>
          <div v-else-if="isProfileLoaded">
            <b-tabs v-model="activeTabIndex" content-class="mt-3">
              <b-tab title="⚙️ Settings" lazy>
                <Profile :profile="profile" v-on:profile-updated="updateProfile" v-on:first-verification-done="navigateToContacts" />
              </b-tab>
              <b-tab title="🤗 Contacts" lazy :disabled="!isContactsEnabled">
                <Contacts />
              </b-tab>
            </b-tabs>
          </div>
          <b-spinner v-else label="Loading..." />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { BCol, BContainer, BRow, BSpinner, BTab, BTabs } from 'bootstrap-vue'
import Login from '../common/login.vue'
import TopBar from '../common/top_bar.vue'
import Contacts from './contacts.vue'
import Info from './info.vue'
import Profile from './profile.vue'
import GenericErrorMixin from '../../libs/generic_error_mixin'
import { isAuthenticated } from '../../libs/auth'
import { jsonApi } from '../../libs/jsonapi'

export default {
  mixins: [GenericErrorMixin],
  data: function () {
    return {
      activeTabIndex: 1,
      isProfileLoaded: false,
      jsonApi: jsonApi,
      navigatedToContacts: false,
      navigatedToSettings: false,
      profile: {}
    }
  },
  mounted: async function () {
    if (!this.isAuthenticated) {
      return;
    }

    try {
      const response = await this.jsonApi.findAll('profile');
      this.profile = response.data;
      this.isProfileLoaded = true;
    }
    catch (error) {
      this.showGenericErrorModal();
    }
  },
  computed: {
    isContactsEnabled() {
      return this.profile.has_verified_once;
    },
    isAuthenticated
  },
  methods: {
    async navigateToContacts() {
      await this.$nextTick(); // To wait for contacts tab to activate after verification
      this.activeTabIndex = 1;
    },
    updateProfile(profile) {
      this.profile = profile;
    }
  },
  components: {
    'b-col': BCol,
    'b-container': BContainer,
    'b-row': BRow,
    'b-spinner': BSpinner,
    'b-tab': BTab,
    'b-tabs': BTabs,
    Contacts,
    Info,
    Login,
    Profile,
    TopBar
  }
}
</script>

<style scoped lang="scss">
.main-content {
  margin-top: 1.5rem;
}
h1 {
  font-weight: bold;
  font-size: 3rem;
  color: #bbb;
}
h4 {
  font-weight: bold;
  color: #bbb;
  font-size: 1.3rem;
  margin-bottom: 1rem;
}
.main-tagline {
  width: 70%;
  color: #666;
}
</style>
